class NSSAnimatedNumber extends HTMLElement {

  constructor() {
    super();

    this.debug = false;
    this.formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', });
    this.MULTIPLY_KG_TO_LB = 2.20462;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Animated Number] Connected.");

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      // Animate Number
      if (this.debug) console.log("[NSS][Animated Number] Observed!");
      const isEcoCart = this.hasAttribute(`nss-ecocart-offset`);
      if (!isEcoCart) {
        const target = this.getAttribute(`nss-animated-number`);
        this.startAnimation(this.querySelector(`[nss-animated-number-d]`), target);
        this.startAnimation(this.querySelector(`[nss-animated-number-m]`), target);
      } else {
        fetch('https://merchant.ecocart.io/merchant/lsg-dev02.myshopify.com')
          .then((e)=>{ return e.json() })
          .then((data) => {
            const raw = data.stats.merchant.all_time.carbon_offset
            const offset = raw * this.MULTIPLY_KG_TO_LB;
            const target = this.roundToTwo(offset / 1000000);
            this.startAnimation(this.querySelector(`[nss-animated-number-d]`), target);
            this.startAnimation(this.querySelector(`[nss-animated-number-m]`), target);
          });
      }
    };
  
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 0px 0px'});
    observer.observe(this);
  }

  roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
  }

  startAnimation(element, endValue) {
    let currentValue = 0;
    let step;
    if (endValue % 1 === 0) {
      step = Math.ceil(endValue / 100);
    } else {
      step = endValue / 100.0;
    }
    const interval = setInterval(() => {
      if (currentValue + step >= endValue) {
        currentValue = endValue;
        clearInterval(interval);
      } else {
        currentValue += step;
      }
      element.textContent = Math.round(currentValue * 10) / 10;
    }, 20);
  } 
}

let elementName = `nss-animated-number`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSAnimatedNumber);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}